const PREFIX = '@SUBSCRIPTIONS';

export const GET_SUBSCRIPTIONS_LIST = "GET_SUBSCRIPTIONS_LIST";
export const GET_SUBSCRIPTIONS_LIST_SUCCEEDED = "GET_SUBSCRIPTIONS_LIST_SUCCEEDED"

export const GET_SUBSCRIPTION_DETAILS = "GET_SUBSCRIPTION_DETAILS";
export const SET_SUBSCRIPTION_DETAILS = "SET_SUBSCRIPTION_DETAILS";
export const SET_ACTIVE_SUBSCRIPTION = "SET_ACTIVE_SUBSCRIPTION"
export const REMOVE_ACTIVE_SUBSCRIPTION = "REMOVE_ACTIVE_SUBSCRIPTION"

export const GET_USAGES = "GET_USAGES";

export const SET_MONTHLY_USAGES = "SET_MONTHLY_USAGES";
export const SET_WEEKLY_USAGES = "SET_WEEKLY_USAGES";
export const SET_CONFIRM_TEXT = "SET_CONFIRM_TEXT";
export const SET_PAYMENT_LINK = "SET_PAYMENT_LINK";

const SUBSCRIPTIONS = `${PREFIX}SUBSCRIPTIONS`;
const SUBSCRIPTIONS_ITEM = `${SUBSCRIPTIONS}:ITEM`;
export const SUBSCRIPTIONS_ITEM_BUY = `${SUBSCRIPTIONS_ITEM}:BUY`;
export const SUBSCRIPTIONS_ITEM_BUY_SUCCEEDED = `${SUBSCRIPTIONS_ITEM_BUY}:SUCCEEDED`;
export const SUBSCRIPTIONS_ITEM_CONFIRM_TEXT = `${SUBSCRIPTIONS_ITEM}:CONFIRM_TEXT`;
export const SUBSCRIPTIONS_SET_PAYMENT_STATUS = `${SUBSCRIPTIONS_ITEM}:SET_PAYMENT_STATUS`;
